module.exports = __webpack_public_path__ + "media/virtualStagingContractMedia/virtualStagingMedia4-3ee4e42a.jpeg";